var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("AlternativesViewDeleterDialog", {
        attrs: { viewModel: _vm.alternativesViewDeleterDialog },
        on: { "delete-list": _vm.handleDeleteAlternativesViewCommand },
      }),
      _vm._v(" "),
      _c("AlternativesViewDependenciesDialog", {
        attrs: { viewModel: _vm.alternativesViewDependenciesDialog },
      }),
      _vm._v(" "),
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-5 text-right align-self-end" }, [
              _c("div", { staticClass: "dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    staticStyle: { padding: "0.7em 2em" },
                    attrs: { type: "button", "data-toggle": "dropdown" },
                  },
                  [
                    _vm._v(
                      "\n                        Create list\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-menu" }, [
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item",
                      on: { click: _vm.createStaticList },
                    },
                    [
                      _c("strong", [_vm._v("Static")]),
                      _c("br"),
                      _vm._v(
                        "\n                            Manage list items manually\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-divider" }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item",
                      on: { click: _vm.createActiveList },
                    },
                    [
                      _c("strong", [_vm._v("Active")]),
                      _c("br"),
                      _vm._v("Dynamic list based on your conditions"),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c("div", { staticClass: "container" }, [
            _c(
              "div",
              {
                staticClass: "row",
                staticStyle: { margin: "0", height: "100%" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "col-sm-3 bg-color-gray4",
                    staticStyle: { height: "100%" },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { margin: "20px 5px" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.listSearchPhrase,
                              expression: "listSearchPhrase",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "search",
                            placeholder: "Type to search...",
                          },
                          domProps: { value: _vm.listSearchPhrase },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.listSearchPhrase = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.listsView, function (l) {
                          return _c(
                            "ul",
                            { key: l.Id, staticClass: "list-group" },
                            [
                              _c(
                                "li",
                                {
                                  staticClass: "list-group-item pointer",
                                  class: {
                                    active: _vm.SelectedView?.Id === l.Id,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.SelectView(l.Id)
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    !l.IsValid
                                      ? _c("i", {
                                          staticClass:
                                            "fa fa-exclamation-triangle fa-lg fg-color-red",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    l.IsValid && !l.IsStatic
                                      ? _c("i", {
                                          staticClass: "fa fa-filter fa-lg",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    l.IsValid && l.IsStatic
                                      ? _c("i", {
                                          staticClass: "fa fa-list fa-lg",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(l.Name))]),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-9" }, [
                  _vm.SelectedView
                    ? _c("div", { staticStyle: { margin: "10px" } }, [
                        _vm.IsEdited === false
                          ? _c("div", [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-sm-6" }, [
                                  _c("h4", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.SelectedView.Name)),
                                    ]),
                                    _vm._v(" "),
                                    _c("small", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(
                                            _vm.SelectedView.Included?.length
                                          ) +
                                          ")"
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-sm-6",
                                    staticStyle: { "text-align": "right" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dropdown d-inline-block",
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "text-dark dropdown-toggle",
                                            attrs: {
                                              "data-toggle": "dropdown",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        Actions\n                                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dropdown-menu dropdown-menu-right",
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: _vm.startListEditing,
                                                },
                                              },
                                              [_vm._v("Edit")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: { click: _vm.cloneList },
                                              },
                                              [_vm._v("Clone")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: _vm.cloneAsStaticList,
                                                },
                                              },
                                              [_vm._v("Save as static list")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click:
                                                    _vm.showListDependenciesViewer,
                                                },
                                              },
                                              [_vm._v("View dependencies")]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "dropdown-divider",
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: _vm.showListDeleter,
                                                },
                                              },
                                              [_vm._v("Delete")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("hr"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.IsEdited === true
                          ? _c("div", [
                              _vm._m(1),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-sm-6" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value: _vm.SelectedView.Name,
                                        expression: "SelectedView.Name",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.SelectedView.Name },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.SelectedView,
                                          "Name",
                                          $event.target.value.trim()
                                        )
                                      },
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-sm-6" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: { role: "button" },
                                      on: { click: _vm.SaveCommand },
                                    },
                                    [_vm._v("Save")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-outline-secondary",
                                      attrs: { role: "button" },
                                      on: { click: _vm.cancelListEditing },
                                    },
                                    [_vm._v("Cancel")]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("br"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.IsEdited && !_vm.SelectedView.IsStatic
                          ? _c("div", [
                              _c("div", { staticClass: "card" }, [
                                _c("div", { staticClass: "card-header" }, [
                                  _c("div", { staticClass: "dropdown" }, [
                                    _vm.filter.Type === "And"
                                      ? _c("span", [
                                          _vm._v(
                                            "Include when all of conditions are met"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.filter.Type === "Or"
                                      ? _c("span", [
                                          _vm._v(
                                            "Include when any of conditions are met"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("a", {
                                      staticClass: "fa fa-cog pointer",
                                      attrs: { "data-toggle": "dropdown" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "dropdown-menu" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "dropdown-header" },
                                          [_vm._v("Include when:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                _vm.filter.Type = "And"
                                              },
                                            },
                                          },
                                          [
                                            _vm.filter.Type === "And"
                                              ? _c("span", {
                                                  staticClass:
                                                    "fa-regular fa-square-check",
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.filter.Type === "Or"
                                              ? _c("span", {
                                                  staticClass:
                                                    "fa-regular fa-square",
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                                            all of conditions are met\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                _vm.filter.Type = "Or"
                                              },
                                            },
                                          },
                                          [
                                            _vm.filter.Type === "Or"
                                              ? _c("span", {
                                                  staticClass:
                                                    "fa-regular fa-square-check",
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.filter.Type === "And"
                                              ? _c("span", {
                                                  staticClass:
                                                    "fa-regular fa-square",
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                                            any of conditions are met\n                                        "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "card-body" },
                                  [
                                    _vm._l(_vm.filter.Filters, function (f) {
                                      return _c(
                                        "div",
                                        [
                                          f.IsPropertyFilter
                                            ? _c("AttributeFilter", {
                                                attrs: {
                                                  propRm: f,
                                                  propAttributes:
                                                    _vm.rm.Attributes,
                                                },
                                                on: {
                                                  deleteFilter:
                                                    _vm.deleteFilter,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          f.IsStatusFilter
                                            ? _c("StatusFilter", {
                                                attrs: {
                                                  propRm: f,
                                                  propStatuses: _vm.rm.Statuses,
                                                },
                                                on: {
                                                  deleteFilter:
                                                    _vm.deleteFilter,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          f.IsMemberFilter
                                            ? _c("ListFilter", {
                                                attrs: {
                                                  propRm: f,
                                                  propViews: _vm.rm.Views,
                                                },
                                                on: {
                                                  deleteFilter:
                                                    _vm.deleteFilter,
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dropdown",
                                        staticStyle: {
                                          display: "inline-block",
                                        },
                                      },
                                      [
                                        _vm._m(2),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dropdown-menu",
                                            staticStyle: {
                                              "max-height": "300px",
                                              "overflow-y": "auto",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "dropdown-header",
                                              },
                                              [_vm._v("Status:")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addFilter(
                                                      "StatusIn"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("is one of")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addFilter(
                                                      "StatusNotIn"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("is none of")]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "dropdown-divider",
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "dropdown-header",
                                              },
                                              [_vm._v("Attribute value:")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addFilter(
                                                      "PropertyEq"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("equal to")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addFilter(
                                                      "PropertyNotEq"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("NOT equal to")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addFilter(
                                                      "PropertyLt"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("is less than")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addFilter(
                                                      "PropertyLte"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "is less than or equal to"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addFilter(
                                                      "PropertyGt"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("is greater than")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addFilter(
                                                      "PropertyGte"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "is greater than or equal to"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addFilter(
                                                      "PropertyIsKnown"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("any value")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addFilter(
                                                      "PropertyIsUnknown"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("no value")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addFilter(
                                                      "PropertyContains"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("contains")]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "dropdown-divider",
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "dropdown-header",
                                              },
                                              [_vm._v("List:")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addFilter(
                                                      "MemberOf"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("is included")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addFilter(
                                                      "NotMemberOf"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("is NOT included")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.alternativesSearchPhrase,
                              expression: "alternativesSearchPhrase",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "search",
                            placeholder: "Type to search by name...",
                          },
                          domProps: { value: _vm.alternativesSearchPhrase },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.alternativesSearchPhrase = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.IsEdited && _vm.SelectedView.IsStatic
                          ? _c(
                              "table",
                              { staticClass: "table table-striped" },
                              [
                                _vm._m(3),
                                _vm._v(" "),
                                _vm._l(_vm.alternativesView, function (a) {
                                  return _c("tbody", { key: a.Id }, [
                                    _c("tr", [
                                      _c("td", [
                                        _vm.IsEditedIncluded(a.AlternativeId)
                                          ? _c("span", {
                                              staticClass:
                                                "fa-regular fa-square-check",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.Exclude(
                                                    a.AlternativeId
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.IsEditedIncluded(a.AlternativeId)
                                          ? _c("span", {
                                              staticClass:
                                                "fa-regular fa-square",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.Include(
                                                    a.AlternativeId
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(a.Name))]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(a.Description))]),
                                    ]),
                                  ])
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.IsEdited
                          ? _c(
                              "table",
                              { staticClass: "table table-striped" },
                              [
                                _vm._m(4),
                                _vm._v(" "),
                                _vm._l(_vm.alternativesView, function (a) {
                                  return _c("tbody", { key: a.Id }, [
                                    _c("tr", [
                                      _c("td", [_vm._v(_vm._s(a.Name))]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(a.Description))]),
                                    ]),
                                  ])
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-7" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
          },
        },
        [_vm._v("Lists")]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "text-muted mb-0" }, [
        _vm._v(
          "Build custom lists to structure and analyse your portfolio by combining Kanban Statuses, Attribute values and existing lists."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-3" }, [
        _c("strong", [_vm._v("List name:")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-6" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        staticClass: "pointer",
        staticStyle: { "font-size": "14px" },
        attrs: { "data-toggle": "dropdown" },
      },
      [
        _c("span", { staticClass: "fa fa-plus" }),
        _vm._v(" "),
        _c("span", [_vm._v("Add condition")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Description")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Description")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }